import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import React, { FC } from 'react';

import { Accordion } from '../Accordion';

import s from './Faq.module.scss';

import { useFetch } from '#root/hooks/use-fetch';
import { useLanguage } from '#root/hooks/use-language';
import { IFaq } from '#root/store/types';

export const Faqs: FC = () => {
  const language = useLanguage();
  const { data: faqs } = useFetch<IFaq[] | null>(`/api/faq/${language}`, null);
  console.log(faqs);
  if (!faqs?.length) return null;

  return (
    <>
      {faqs.map(faq => (
        <Accordion
          preTitle={<QuestionMarkIcon />}
          title={<span className={s.title}>{faq.title}</span>}
          key={faq.id}
        >
          <div className={s.content}>
            <div dangerouslySetInnerHTML={{ __html: faq.content }} />
          </div>
        </Accordion>
      ))}
    </>
  );
};
